/*
 * ew-pdp-gallery.js
 *
 * Interaction layer for the shared EW PDP media gallery
 * (snippets/ew-pdp-gallery.liquid). ONE source of truth for the
 * thumb / variant -> main-stage swap.
 *
 * The main stage [data-ew-pdp-main] holds every attached media item as its
 * own stacked [data-ew-pdp-stage] element (image, video, external_video, or
 * the bundle cover), one visible and the rest [hidden]. Swapping is an
 * ELEMENT TOGGLE — not an src-swap — so the stage can hold a <video> that
 * plays in place. Any playing <video>/embed is PAUSED when switched away.
 *
 * Behavior:
 *   - Click a [data-ew-pdp-thumb] -> show the matching stage item by
 *     data-media-id (document-delegated, so load order / dynamic DOM are moot).
 *   - Sections drive variant -> stage swaps via
 *       window.EWPdpGallery.show(sectionRootOrGallery, mediaId)
 *     (e.g. a finish/colour whose variant.featured_media is a distinct image).
 *
 * assets/ew-lightbox.js zooms IMAGES only; videos are inline here.
 *
 * Vanilla / ES5-safe. No deps.
 */
(function () {
  'use strict';

  if (!document.querySelector || !document.addEventListener) return;

  function forEach(list, fn) { Array.prototype.forEach.call(list || [], fn); }

  /* Accept either the [data-ew-pdp-gallery] element itself or any ancestor
     (a section root) that contains exactly one gallery. */
  function galleryOf(scope) {
    if (!scope) return null;
    if (scope.matches && scope.matches('[data-ew-pdp-gallery]')) return scope;
    return scope.querySelector ? scope.querySelector('[data-ew-pdp-gallery]') : null;
  }

  /* Stop playback of anything inside a stage item we're about to hide:
     pause native <video>, and hard-stop external embeds (YouTube/Vimeo) by
     re-writing their iframe src. */
  function stopMedia(item) {
    if (!item) return;
    forEach(item.querySelectorAll('video'), function (v) {
      try { v.pause(); } catch (e) {}
    });
    forEach(item.querySelectorAll('iframe'), function (f) {
      var src = f.getAttribute('src');
      if (src) f.setAttribute('src', src); /* reload = stop playback */
    });
  }

  /* Show the stage item whose data-media-id === id; hide + stop the rest;
     mirror the selected state onto the thumbs. Returns true if a match showed. */
  function show(scope, id) {
    var gallery = galleryOf(scope);
    if (!gallery || id === null || id === undefined) return false;
    id = String(id);

    var items = gallery.querySelectorAll('[data-ew-pdp-stage]');
    var target = null;
    forEach(items, function (item) {
      if (item.getAttribute('data-media-id') === id) target = item;
    });
    if (!target) return false;

    forEach(items, function (item) {
      if (item === target) {
        item.hidden = false;
      } else {
        if (!item.hidden) stopMedia(item);
        item.hidden = true;
      }
    });

    forEach(gallery.querySelectorAll('[data-ew-pdp-thumb]'), function (t) {
      t.setAttribute('aria-pressed', t.getAttribute('data-media-id') === id ? 'true' : 'false');
    });
    return true;
  }

  /* Delegated thumb click — covers every gallery on the page, incl. content
     added after boot. Bundle-cover thumbs carry data-media-id="cover" and map
     to the cover stage item, so no special-case is needed here. */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ew-pdp-thumb]') : null;
    if (!btn) return;
    var gallery = btn.closest('[data-ew-pdp-gallery]');
    if (!gallery) return;
    var id = btn.getAttribute('data-media-id');
    if (id !== null) show(gallery, id);
  });

  window.EWPdpGallery = { show: show };
})();
